export default "__VITE_ASSET__DTiGmrs$__"